import { MENU_BASE_URLS } from "./url.constants"

export const PAGE_CONSTANTS = {
  GLOBAL_PARTICIPANT_DATA_GRID_PAGE: `GLOBAL_PARTICIPANT_GRID`,
  PARTICIPANT_REFERRAL_DATA_GRID_PAGE: `PARTICIPANT_REFERRAL_GRID`,
  PARTICIPANT_ENROLLMENT_DATA_GRID_PAGE: `PARTICIPANT_ENROLLMENT_GRID`,
  AUTHORIZATION_DATA_GRID_PAGE: `AUTHORIZATION_GRID`,
  PROVIDER_ENROLLMENT_DATA_GRID_PAGE: `PROVIDER_ENROLLMENT_GRID`,
  FILE_TRIAGE_DATA_GRID_PAGE: `FILE_TRIAGE_GRID`,
  FILE_UPLOAD_NOTIFICATION_DATA_GRID_PAGE: `FILE_UPLOAD_NOTIFICATION_GRID`,
  PARTICIPANT_LEADS_DATA_GRID_PAGE: `PARTICIPANT_LEAD_GRID`,
  PROVIDER_LEADS_DATA_GRID_PAGE: `PROVIDER_LEAD_GRID`,
  PAYROLL_PROCESSING_GRID_PAGE: `PAYROLL_PROCESSING_GRID_PAGE`,
  ENROLLMENT_DATA_GRID_PAGE: `ENROLLMENT_GRID`,
  PROCESS_CODE_GRID_PAGE: `PROCESS_CODE_GRID`,
  SERVICE_CODE_GRID_PAGE: `SERVICE_CODE_GRID`,
  CASE_MANAGER_GRID_PAGE: `CASE_MANAGER_GRID`,
  PARTICIPANT_PROVIDER_RATES_GRID_PAGE: `PARTICIPANT_PROVIDER_RATES_GRID`,
  PAYABLE_PROVIDER_RATES_GRID_PAGE: `PAYABLE_PROVIDER_RATES_GRID`,
  BILLABLE_PROVIDER_RATES_GRID_PAGE: `BILLABLE_PROVIDER_RATES_GRID`,
  MEMBER_INFORMATION: `MEMBER_INFORMATION`,
  BATCHES_GRID_PAGE: `BATCHES_GRID`,
  BILLING_FILES_GRID_PAGE: `BILLING_FILES_GRID`,
  CLAIMS_GRID_PAGE: `CLAIMS_GRID`,
  CLAIMS_PMPM_GRID_PAGE: `CLAIMS_PMPM_GRID`,
  RECON_FILES_GRID_PAGE: `RECON_FILES_GRID`,
  PAYMENT_RECON_GRID_PAGE: `PAYMENT_RECON_GRID`,

  PAYLIST_DATA_GRID_PAGE: `PAYLIST_TRIAGE_GRID`,
  PAYLIST_DETAIL_DATA_GRID_PAGE: `PAYLIST_DETAIL_TRIAGE_GRID`,
  CONFIG_GRID_PAGE: `CONFIG_CODE_GRID`,
  STAFF_TIMESHEETS: `STAFF_TIMESHEETS`,
  STAFF_PENDED_TIMESHEETS: `STAFF_PENDED_TIMESHEETS`,
  STAFF_GOODTOPAY_TIMESHEETS: `STAFF_PENDED_TIMESHEETS`,
  STAFF_INVOICES: `STAFF_INVOICES`,
  STAFF_PENDED_INVOICES: `STAFF_PENDED_INVOICES`,
  STAFF_PURCHASE_REQUESTS: `STAFF_PURCHASE_REQUESTS`,
  STAFF_PAYROLL_ADJUSTMENT: `STAFF_PAYROLL_ADJUSTMENT`,
  STAFF_REVERT_ADJUSTMENT: `STAFF_REVERT_ADJUSTMENT`,
  STAFF_CHEQUE_VOID: `STAFF_CHEQUE_VOID`,
  STAFF_NAV_RESET: `STAFF_NAV_RESET`,
  STAFF_REPROCESS: `STAFF_REPROCESS`,
  STAFF_INVOICE_PAYROLL_PROCESSING: `STAFF_INVOICE_PAYROLL_PROCESSING`,
  STAFF_TIMESHEET_PAYROLL_PROCESSING: `STAFF_TIMESHEET_PAYROLL_PROCESSING`,
  STAFF_INVOICE_ADJUSTMENT: `STAFF_INVOICE_ADJUSTMENT`,
  STAFF_PURCHASE_ADJUSTMENT: `STAFF_PURCHASE_ADJUSTMENT`,
  STAFF_MASS_ADJUSTMENTS: `STAFF_MASS_ADJUSTMENTS`,
  STAFF_PAYROLL_RESURRECT: `STAFF_PAYROLL_RESURRECT`,
  STAFF_PAYROLL_ADJUSTMENT_APPROVALS: `STAFF_PAYROLL_ADJUSTMENT_APPROVALS`,
  STAFF_INVOICE_ADJUSTMENT_APPROVALS: `STAFF_INVOICE_ADJUSTMENT_APPROVALS`,
  STAFF_PURCHASE_REQUEST_APPROVALS: `STAFF_PURCHASE_REQUEST_APPROVALS`,
  STAFF_CLAIM_ADJUSTMENT: `STAFF_CLAIM_ADJUSTMENT`,
  STAFF_BILLING_ADJUSTMENT: `STAFF_BILLING_ADJUSTMENT`
}

// Maps each configurable list page to its full set of action button IDs.
// Used to compute actionsToBeHidden from the role's allowedActions.
export const PAGE_AVAILABLE_ACTIONS: Record<string, string[]> = {
  [PAGE_CONSTANTS.PARTICIPANT_LEADS_DATA_GRID_PAGE]:    ['send_sms', 'send_email', 'send_registration', 'assign_to_user', 'assign_to_me', 'Approve', 'Deny', 'Resurrect'],
  [PAGE_CONSTANTS.PROVIDER_LEADS_DATA_GRID_PAGE]:        ['send_sms', 'send_email', 'send_registration', 'assign_to_user', 'assign_to_me', 'Approve', 'Deny', 'Resurrect'],
  [PAGE_CONSTANTS.PARTICIPANT_REFERRAL_DATA_GRID_PAGE]:  ['send_sms', 'send_email', 'send_registration', 'assign_to_user', 'assign_to_me', 'Approve', 'Deny', 'Resurrect'],
  [PAGE_CONSTANTS.PARTICIPANT_ENROLLMENT_DATA_GRID_PAGE]:['send_sms', 'send_email', 'send_registration', 'assign_to_user', 'assign_to_me'],
  [PAGE_CONSTANTS.PROVIDER_ENROLLMENT_DATA_GRID_PAGE]:   ['send_sms', 'send_email', 'send_registration', 'assign_to_user', 'assign_to_me'],
  [PAGE_CONSTANTS.AUTHORIZATION_DATA_GRID_PAGE]:         ['Approve', 'Deny', 'EditAuthorization', 'Clone', 'EditSpendingPlan'],
  [PAGE_CONSTANTS.STAFF_TIMESHEETS]:                     ['TimesheetAdjust'],
  [PAGE_CONSTANTS.STAFF_PENDED_TIMESHEETS]:              ['TimesheetAdjust'],
  [PAGE_CONSTANTS.STAFF_GOODTOPAY_TIMESHEETS]:           ['TimesheetAdjust'],
  [PAGE_CONSTANTS.FILE_TRIAGE_DATA_GRID_PAGE]:           ['file_triage_assign'],
  [PAGE_CONSTANTS.FILE_UPLOAD_NOTIFICATION_DATA_GRID_PAGE]: ['file_upload_notification'],
  [PAGE_CONSTANTS.PAYROLL_PROCESSING_GRID_PAGE]:         ['submit_for_processing'],
};

// Allow-list action on AUTHORIZATION_GRID that permits renaming an existing auth's spending plan (clientAuth).
export const AUTHORIZATION_EDIT_SPENDING_PLAN_ACTION = 'EditSpendingPlan';


export const MEMBER_VIEW_PAGE_IDS = {
  [MENU_BASE_URLS.PROVIDER_LEADS]: 'PROVIDER_MEMBER_VIEW',
  [MENU_BASE_URLS.PARTICIPANT_LEADS]: 'PARTICIPANT_MEMBER_VIEW',
  [MENU_BASE_URLS.REFERRAL]: "REFERRAL_MEMBER_VIEW",
  [MENU_BASE_URLS.PARTICIPANT_ENROLLMENT]: "ENROLLED_PARTICIPANT_MEMBER_VIEW",
  [MENU_BASE_URLS.PROVIDER_ENROLLMENT]: "ENROLLED_PROVIDER_MEMBER_VIEW",
  [MENU_BASE_URLS.GLOBAL_PARTICIPANT_SEARCH]: "GLOBAL_PARTICIPANT_SEARCH_MEMBER_VIEW",
  [MENU_BASE_URLS.EXTERNAL_MEMBERS]: "EXTERNAL_MEMBER_VIEW",
  [MENU_BASE_URLS.AUTHORIZATIONS]: "AUTHORIZATION_MEMBER_VIEW",
}


export const TABS = {
  TIMESHEET: 'TIMESHEET',
  ProspectiveInformation: 'ProspectiveInformation',
  Associations: 'Associations',
  Authorization: 'Authorizations',
  EnrollmentInformation: 'EnrollmentInformation',
  SickTime: 'SickTime',
  Checklist: 'Checklist',
  Documents: 'Documents',
  Signature: 'Signature',
  Forms: 'Forms',
  AdditionalAttributes: 'AdditionalAttributes',
}

export const MenuIDs = {
  GlobalConsumerSearch: 'globalConsumerSearch',
  ConsumerReferral: "consumerReferral",
  PersonalAssistantRegistration: "personalAssistantRegistration",
  ParticipantProviderRates: "participantProviderRates",
  PayableProviderRates: "payableProviderRates",
  ProcessCodes: "processCodes",
  ServiceCodes: "serviceCodes",
  ViewBatches: "viewBatches",
  ApplicationConfig: "applicationConfig",
  ViewFiles: "viewFiles",
  ViewClaims: "viewClaims",
  FileTriage: "fileTriage",
  FileUploadNotification: "fileUploadNotification",
  PayrollProcessing: "payrollProcessing",
  PayrollNATPay: "payrollNATPay",
  PayrollAdjustment: "payrollAdjustment",
  PayrollApprovals: "payrollApprovals",
  BillingAdjustment: "billingAdjustment",
  BillingApprovals: "billingApprovals",
  Authorizations: "authorizations",
  Timesheets: "timesheets",
  Invoices: "invoices",
  PurchaseRequests: "purchaseRequests",
  PendedTimesheets: "pendedTimesheets",
  CaseManagers: "independentFacilitator",
  AuthUtilizationAnalysis: "authUtilizationAnalysis",
  PayrollResurrect: "payrollResurrect"
}